import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import { Button, Table } from "react-bootstrap";
import { useEventContext } from "../../../../context";
import { getShopProductOrderReport } from "../../../../../api/cp/shop";

export default () => {
    const { event } = useEventContext();

    const [orders, setOrders] = useState([]);

    const getReport = async () => {
        try {
            const _orders = await getShopProductOrderReport(event.eventKey);
            setOrders(_orders || []);
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getReport();
    }, [])

    return (<div>
        <div style={{margin: '1rem 0'}}>
            <a href={`/api/cp/event/${event.eventKey}/module/shop/product/orders/report.xlsx`}><Button bsStyle={'success'}>Скачать</Button></a>            
        </div>
        <Table>
            <thead>
                <tr>
                    <th width={100}>ID приза</th>
                    <th width={200}>Дата и время покупки</th>
                    <th>Название</th>
                    <th width={100}>Стоимость</th>
                    <th width={150}>ID участника</th>
                    <th width={150}>Имя</th>
                    <th width={150}>Отчество</th>
                    <th width={150}>Фамилия</th>
                    <th width={150}>E-mail</th>
                    <th width={150}>Телефон</th>
                </tr>
            </thead>
            <tbody>
                {orders.map((order, idx) => (
                    <tr key={idx}>
                        <td>{order.productId}</td>
                        <td>{moment(order.createdAt).format("DD.MM.YYYY HH:mm:ss")}</td>
                        <td>{order.productTitle}</td>
                        <td>{order.price}</td>
                        <td>{order.clientRegistration.id}</td>
                        <td>{order.clientRegistration.info.name}</td>
                        <td>{order.clientRegistration.info.patronymic}</td>
                        <td>{order.clientRegistration.info.surname}</td>
                        <td>{order.clientRegistration.email}</td>
                        <td>{order.clientRegistration.info.phone}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>);
}
